import { render, staticRenderFns } from "./DigikalaForm.vue?vue&type=template&id=49569f27"
import script from "./DigikalaForm.vue?vue&type=script&lang=js"
export * from "./DigikalaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports